import { createRoutingURI, getRootSlug } from '@scripts/utils/domain';
import { TeaserNewsProps } from 'ech-components/src/components/TeaserNews';
import { getRootTranslation } from '../../gatsby-helper';
import { IntlShape } from 'react-intl';

const teaserNewsService = (news: [], intl: IntlShape) => {
  const teaserNewsProps: TeaserNewsProps = news.length
    ? {
        items: news.map((node: { linkText: string; href: string }) => {
          node.linkText = intl.formatMessage({
            id: `hub.teaser.more.news`,
          });

          node.href = createRoutingURI(getRootSlug(node, intl.locale));

          return node;
        }),
        title: intl.formatMessage({
          id: `page.navigation.news`,
        }),
        newsHref: createRoutingURI({
          slug: '',
          root: getRootTranslation('news', intl.locale),
          locale: intl.locale,
        }),
        labels: {
          showMore: intl.formatMessage({
            id: `hub.teaser.showmore.news`,
          }),
        },
      }
    : null;

  return teaserNewsProps;
};

export default teaserNewsService;
